import React, { ReactNode, useEffect, useRef } from "react";
import { StyledContainer, StyledContent, StyledScrollable } from "./modal.styles";

export const Modal = ({ children, onClickOutside }: { children: ReactNode, onClickOutside?: () => void }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleDocumentClick = (event: MouseEvent) => {
      if (contentRef.current && !contentRef.current.contains(event.target as Node)) {

        event.preventDefault();
        if (onClickOutside) {
          onClickOutside();
        }
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);

    return () => {
      document.removeEventListener("mousedown", handleDocumentClick);
    };
  }, [onClickOutside]);

  useEffect(() => {
    document.body.classList.add("no-scroll");

    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  return (
    <StyledContainer>
      <StyledContent ref={contentRef}>
        <StyledScrollable>
          {children}
        </StyledScrollable>
      </StyledContent>
    </StyledContainer>
  );
}
